.truncated {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
